<div
  class="atn-model-card"
  [style.width]="widthSg()"
>
  <div class="atn-model-card__header">
    <div class="atn-model-card__main">
      <div class="atn-model-card__title">{{ modelNameSg() }}</div>
    </div>
    @if (modelSg()) {
      <atn-ds-tag [text]="modelTypeSg()" />
    }
  </div>
  <p class="atn-model-card__body">
    {{ modelDescriptionSg() }}
  </p>
</div>
